import dynamic from 'next/dynamic';

import { CrossSellOffersProps } from './CrossSellOffers.types';

export const CrossSellOffers = dynamic<CrossSellOffersProps>(() =>
  import('./CrossSellOffers').then(module => module.CrossSellOffers)
);
